import { mockApi } from "./mock";
import { wsApi } from "./ws";
export * from "../types/conversationTypes";

const USE_MOCK_DATA = (import.meta.env.VITE_USE_MOCK_DATA ?? "false").toLowerCase() === "true";

export const chatApi = USE_MOCK_DATA ? mockApi : wsApi;
export const isMockEnabled = () => USE_MOCK_DATA;
